module.exports = __webpack_public_path__ + "static/FixedGridLarge-f2cef7adae308f0802b51cf4edac611c.gif";